import * as React from 'react';
import HelpPage from '../help/HelpPage';
import mdFile from '../help/MappingTables.md'

export default function LocationsHelpPage(props = {}) {

  return (
    <HelpPage
      previousPage="/locations/list"
      pageName="Locations Help"
      mdFile={mdFile}
      {...props}
    />
  )
}